import { useAppSelector } from 'store/hook';

// get the info current logged in user from external or internal user list
export const useCurrentUserInfo = () => {
  const userInfo = useAppSelector((state) => state?.authReducer?.userInfo);
  return userInfo;
};
